
import React from 'react';
import { Control, FieldErrors } from 'react-hook-form';
import { FormInputTextField } from '../../fields/FormInputTextField';
import { JobSearchFormData } from '../../JobSearchFormSchema';

interface KeywordsInputProps {
  control: Control<JobSearchFormData>;
  errors: FieldErrors<JobSearchFormData>;
  isLoading: boolean;
}

export const KeywordsInput: React.FC<KeywordsInputProps> = ({
  control,
  errors,
  isLoading,
}) => {
  return (
    <FormInputTextField
      name="keywords"
      control={control}
      label="Keywords (Optional)"
      placeholder="e.g., startup, remote, growth stage"
      error={errors.keywords}
      disabled={isLoading}
    />
  );
};
